import locale from '@landing/common/consts/locale'
import parse from 'date-fns/parse'

export default function birthStrToDate(str, pattern = 'yyyy-MM-dd') {
  // locale 應該以出生地為準，因為 db 沒有紀錄，都先用台灣時區計算
  return parse(str, pattern, new Date(), { locale })
}
